import { SearchQueryOrderDirection, TemplateDeploymentType } from "types/generated";

export const TEMPLATE_DEPLOYMENT_TYPE_LABEL: Record<TemplateDeploymentType, string> = {
  [TemplateDeploymentType.Regular]: "REGULAR",
  [TemplateDeploymentType.Test]: "TEST",
};

export const initialSortOption = "createdAt";
export const initialSortDirection = SearchQueryOrderDirection.Desc;

export const DEPLOYMENTS_LIMIT = 50;

export const FILTERS_ORDER_SETTINGS_KEY = "templateDeploymentsFiltersOrder";

export const REFETCH_QUERIES_LIST = [
  "SearchTemplateDeployments",
  "SearchTemplateDeploymentsSuggestions",
];

export const FILTER_TYPE = "templateDeployments";
export const DEPLOYMENTS_LIMIT_STORAGE_KEY = "templateDeploymentsLimit";
